import DashboardRoute from "./dashboard/Dashboard.Route";
import MasterRoute from './master/MasterRoute';
import SettingsRoute from './settings/SettingsRoute';
import UsersRoute from './users/UsersRoute';
import CompanyRoute from './company/CompanyRoute';
import OnlineClassRoute from './online_class/OnlineClassRoute';
import AssignRoute from './assign/AssignRoute';
import AssignmentRoute from './assignment/AssignmentRoute';
import PaperGenerationRoute from './paper_generation/PaperGenerationRoute';
import ClassRoute from './class/ClassRoute';
import DayRoute from './day/DayRoute';
import TopicRoute from './topic/TopicRoute';
import RegistrationRoute from './registration/RegistrationRoute';
import PaymentRoute from './payment/PaymentRoute';
import AmountRoute from './amount/AmountRoute';
import StudentExamRoute from './student_exam/StudentExamRoute';

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...MasterRoute(),
        ...SettingsRoute(),
        ...UsersRoute(),
        ...CompanyRoute(),
        ...OnlineClassRoute(),
        ...AssignRoute(),
        ...AssignmentRoute(),
        ...PaperGenerationRoute(),
        ...ClassRoute(),
        ...DayRoute(),
        ...TopicRoute(),
        ...RegistrationRoute(),
        ...PaymentRoute(),
        ...AmountRoute(),
        ...StudentExamRoute(),
    ]
}

export default PrivateRoute